export default __webpack_public_path__ + "img/x-circle-black.31354aa7.svg";